import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBHkHJvXtqYQxIHXmtw32OkC4k2kCy42fs",
  authDomain: "eliada-sports-agency.firebaseapp.com",
  databaseURL: "https://eliada-sports-agency-default-rtdb.firebaseio.com",
  projectId: "eliada-sports-agency",
  storageBucket: "eliada-sports-agency.firebasestorage.app",
  messagingSenderId: "167890449683",
  appId: "1:167890449683:web:46293b06c90c7abfb496e6",
  measurementId: "G-GM0PM1HR3W"
};

export const app = initializeApp(firebaseConfig);
export const analytics = typeof window !== "undefined" ? getAnalytics(app) : null;
export const db = getFirestore(app);
export const auth = getAuth(app);
